import axios from 'axios'
import Config from '@/config.js';
import Cookies from 'js-cookie';
import utils from './utils';

var $http = axios.create({
    baseURL: Config.apiUrl,
    timeout: 55000,
    headers: {}
});
$http.interceptors.request.use(
    config => {
        if (Cookies.get('token')) {
            config.headers['token'] = Cookies.get('token');
        }
        if (Cookies.get('uid')) {
            config.headers['uid'] = Cookies.get('uid');
        }
        if (Cookies.get('theOne')) {
            config.headers['theOne'] = Cookies.get('theOne');
        }
        if(!(Cookies.get('source')==="ios"||Cookies.get('source')==="android")){
            config.headers.source = 'web';
        }else{
            config.headers.source = Cookies.get('source');
        }

        return config;
    }
)
$http.interceptors.response.use(
    response => {
        //移动端做不同处理
        if(response.data.code == 401 && !(Cookies.get('source')==="ios"||Cookies.get('source')==="android")){
            //保证登录信息过期5秒内只提示1次
            if(Cookies.get('errorMsg') !== '1'){
                Cookies.set('errorMsg','1');
                setTimeout(()=>{
                    Cookies.set('errorMsg','0');
                },5000);
                utils.notice("登入信息过期，请重新登录", 'error');
            }

            utils.clearUserCookie();
            window.location.reload();
        }else{
            return response.data;
        }
    },
    error => {//这是异常
        if (error.response) {
            const code = error.response.status;
            if (code == 401) {
                utils.notice("认证失败，请重新登录", 'error');
                utils.clearUserCookie();
                window.location.reload();
            }
            if (code == 500) {
                utils.notice("接口错误，请联系管理员", 'error');
            }
            if (code == 404) {
                utils.notice("404 NOT FOUND", 'error');
            }
            if (code == 422) {
                for (let name in error.response.data) {
                    let msg = (error.response.data[name][0]);
                    utils.notice(`数据验证未通过 -- ${msg}`, 'error');
                    break;
                }
            }
        } 
        return Promise.reject(error)
    }
);

export default $http;


// WEBPACK FOOTER //
// ./src/resource.js